/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeCitybuildStatusListResponse,
  Citybuild
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type citybuildStatusListStatusesResponse200 = {
  data: ApiEnvelopeCitybuildStatusListResponse
  status: 200
}

export type citybuildStatusListStatusesResponseSuccess = (citybuildStatusListStatusesResponse200) & {
  headers: Headers;
};
;

export type citybuildStatusListStatusesResponse = (citybuildStatusListStatusesResponseSuccess)

export const getCitybuildStatusListStatusesUrl = () => {




  return `/api/citybuild-status`
}

export const useCitybuildStatusListStatusesHook = (): ( options?: RequestInit) => Promise<citybuildStatusListStatusesResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getCitybuildStatusListStatusesUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type citybuildStatusResetStatusResponse200 = {
  data: ApiEnvelopeCitybuildStatusListResponse
  status: 200
}

export type citybuildStatusResetStatusResponseSuccess = (citybuildStatusResetStatusResponse200) & {
  headers: Headers;
};
;

export type citybuildStatusResetStatusResponse = (citybuildStatusResetStatusResponseSuccess)

export const getCitybuildStatusResetStatusUrl = (citybuild: Citybuild,) => {




  return `/api/citybuild-status/${citybuild}/reset`
}

export const useCitybuildStatusResetStatusHook = (): (citybuild: Citybuild, options?: RequestInit) => Promise<citybuildStatusResetStatusResponse> => {

      const customFetcher = useSfetchMutator();
      return (citybuild: Citybuild, options?: RequestInit) => {

        return customFetcher(getCitybuildStatusResetStatusUrl(citybuild),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


